module.exports = __webpack_public_path__ + "img/capitalbox@2x.9dae517.png";